/*Recurso: Catalogs - Servicio de lectura del API: Maneja los catálogos utilizados
  Tareas:
    GetAllOrigin              //Origen del cambio        //*Propuesta
    GetAllProcessByFrequency  //Procesos por frecuencia  //*Propuesta  
    GetAllDecision            //...........              //*RP *RD    
    GetAllQuality             //...........              //*RP
    GetAllCycles              //...........              //*RD
*/

import axios from "axios";
//import {IGetAllOrigin} from "./catalogs.modelo";
//import {IGetAllProcessByFrequency} from "./catalogs.modelo";

const API_URL = process.env.REACT_APP_API_URL + 'Catalogs/';

  //se genera una función por cada tarea del recurso api
    const cargaGetAllOrigin = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllOrigin/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllOrigin/es', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllProcessByFrequency= async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllProcessByFrequency/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllProcessByFrequency/es', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllDecision= async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllDecision',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllDecision', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllQuality= async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllQuality',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllQuality', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllCycles = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllCycles/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllCycles/es', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    const cargaGetAllProof = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllProof',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllProof', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

const catalogsService = {
    cargaGetAllOrigin: cargaGetAllOrigin, //Propuesta
    cargaGetAllProcessByFrequency: cargaGetAllProcessByFrequency,  //Propuesta
    cargaGetAllDecision: cargaGetAllDecision, //RD //RP
    cargaGetAllQuality: cargaGetAllQuality, //RP
    cargaGetAllCycles: cargaGetAllCycles, //RP
    cargaGetAllProof: cargaGetAllProof,  //RD
};

export default catalogsService;
